<template>
  <md-field
    class="input"
    :class="{ &quot;md-invalid&quot;: errors.length }"
  >
    <label
      v-if="label"
      :class="{ 'force-label-outside': isLabelOutside }"
    >
      {{ label }}
    </label>
    <md-input
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      v-bind="inputProps"
      @input="onChange"
      @blur.native="onBlur"
    />

    <template v-if="errors.length && !isHiddenErrorDetail">
      <span
        v-for="(error, index) in errors"
        :key="`error-${index}`"
        class="md-error"
      >
        {{ error }}
      </span>
    </template>

    <div
      v-if="suffix"
      class="suffix"
    >
      <span>{{ suffix }}</span>
    </div>
  </md-field>
</template>

<script>
  export default {
    name: 'XInput',
    model: {
      prop: 'value',
      event: 'update'
    },
    props: {
      inputProps: {
        type: Object,
        default: () => ({})
      },
      value: {
        type: [String, Number]
      },
      label: {
        type: String,
        default: null
      },
      placeholder: {
        type: [String, Number],
        default: null
      },
      errors: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      },
      suffix: {
        type: String,
        required: false
      },
      isHiddenErrorDetail: Boolean,
      isLabelOutside: Boolean
    },
    data () {
      return {
        newValue: this.value
      }
    },
    methods: {
      onChange (val) {
        this.newValue = val
        this.$emit('update', val)
      },
      onBlur () {
        this.$emit('blur', this.newValue)
      }
    }
  }
</script>
<style lang='scss' rel='stylesheet/scss' scoped>
  .input {
    label.force-label-outside {
      top: initial;
      bottom: 48px;
      font-size: 1.2rem;
      text-transform: uppercase;
      opacity: 1;
    }
  }
</style>